import i18n from '@vue-storefront/i18n';
import { mapActions, mapGetters, mapState } from 'vuex'
import { Logger } from "@vue-storefront/core/lib/logger";
import RootState from '@vue-storefront/core/types/RootState'
import updateObject from "@vue-storefront/core/scripts/utils/update-object";
import checkoutInitialState from "@vue-storefront/core/modules/checkout/store/checkout/initial-state";

export const Shipping = {
  name: 'Shipping',
  beforeDestroy () {
    this.$bus.$off('checkout-after-personalDetails', this.onAfterPersonalDetails)
    this.$bus.$off('checkout-after-shippingset', this.onAfterShippingSet)
    this.$bus.$off('checkout-after-address-selected', this.sendDataToCheckout)
    this.$bus.$off('user-after-loggedin', this.getActiveShippingAddressId)
    this.$bus.$off('set-guest-address-as-shipping-address', this.setGuestAddressAsShippingAddress)
  },
  beforeMount () {
    this.$bus.$on('checkout-after-personalDetails', this.onAfterPersonalDetails)
    this.$bus.$on('checkout-after-shippingset', this.onAfterShippingSet)
    this.$bus.$on('checkout-after-address-selected', this.sendDataToCheckout)
    this.$bus.$on('user-after-loggedin', this.getActiveShippingAddressId)
    this.$bus.$on('set-guest-address-as-shipping-address', this.setGuestAddressAsShippingAddress)
  },
  data () {
    return {
      isFilled: false,
      saveToMyAddress: false,                 // save new Address to Address Book
      myAddressDetails: {
        firstname: '',
        lastname: '',
        country: '',
        state: '',
        city: '',
        street: '',
        house: '',
        apartment: '',
        postcode: '',
        telephone: '',
        comment: '',
        longitude: '',
        latitude: '',
        api_details: ''
      },
      shippingMethods: [
        {
          "method_title": "Платна доставка",
          "method_code": "delivery",
          "carrier_code": "delivery",
          "amount": 70,
          "price_incl_tax": 70,
          "default": true,
          "offline": true
        },
        {
          "method_title": "Безкоштовна доставка",
          "method_code": "freeshipping",
          "carrier_code": "freeshipping",
          "amount": 0,
          "price_incl_tax": 0,
          "default": true,
          "offline": true
        },
        {
          "method_title": "Безкоштовний самовивіз",
          "method_code": "pickup",
          "carrier_code": "pickup",
          "amount": 0,
          "price_incl_tax": 0,
          "default": true,
          "offline": true
        }
      ],
      otherReceiver: false
    }
  },
  computed: {
    ...mapState({
      currentUser: (state: RootState) => state.user.current,
      shipping: (state: RootState) => state.checkout.shippingDetails
    }),
    ...mapGetters({
      cartTotals: 'cart/getTotals',
      firstUserShippingDetails: 'checkout/getFirstUserShippingDetails',
      isLoggedIn: 'user/isLoggedIn',
      addresses: 'address/getAddressList',
      defaultAddress: 'address/getDefaultAddress',
      shippingDetailsState: 'shipping/getShippingDetailsState',
      getAllowedCountries: 'configs/getAllowedCountries'
    }),
    checkoutShippingDetails () {
      return this.$store.state.checkout.shippingDetails
    },
    paymentMethod () {
      return this.$store.state.payment.methods
    }
  },
  watch: {
    shippingMethods: {
      handler () {
        this.checkDefaultShippingMethod()
      }
    },
    shipping: {
      deep: true,
      handler: function () {
        this.sendDataToCheckout()
      }
    }
  },
  async mounted () {
    if (localStorage.getItem('shop/checkoutFieldValues/shipping-details-state')) {
      const localStorageShippingDetailsState = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/shipping-details-state'));
      this.updateShippingDetailsState(localStorageShippingDetailsState);
      this.saveToMyAddress = localStorageShippingDetailsState.saveToAddressBock;
    }

    if ((!this.isLoggedIn || !this.shippingDetailsState.shipToMyAddress) && localStorage.getItem('shop/checkoutFieldValues/shipping-details')) {
      let localStorageData = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/shipping-details'))
      this.loadDataFromStorage(this.shipping, localStorageData)
      this.$bus.$emit('address-autocomplete-set-search', this.shipping)
    }

    this.checkDefaultShippingMethod()
    this.processShippingMethods()
    this.getActiveShippingAddressId()

    if (!this.currentUser) {
      this.getGuestShippingDetails();
    }

    this.sendDataToCheckout()
  },
  methods: {
    processShippingMethods () {
      if(this.cartTotals[0].value > 1500) {
        this.shippingMethods.shift();
      }
    },
    checkDefaultShippingMethod () {
      if (!this.shipping.shippingMethod || this.notInMethods(this.shipping.shippingMethod)) {
        let shipping = this.shippingMethods.find(item => item.default)
        if (!shipping && this.shippingMethods && this.shippingMethods.length > 0) {
          shipping = this.shippingMethods[0]
        }
        this.saveShippingDetails(updateObject(this.shipping, {
          shippingMethod: shipping.method_code,
          shippingCarrier: shipping.carrier_code
        }));
      }
    },
    onAfterShippingSet (receivedData) {
      this.saveShippingDetails(receivedData);
      this.isFilled = true;
    },
    onAfterPersonalDetails (receivedData) {
      this.changeShippingMethod()
      if (!this.isFilled || !this.otherReceiver) {
        this.$store.dispatch('checkout/updatePropValue', ['firstName', receivedData.firstName])
        this.$store.dispatch('checkout/updatePropValue', ['lastName', receivedData.lastName])
      }
    },
    sendDataToCheckout () {
      this.$bus.$emit('checkout-after-shippingDetails', this.shipping, this.$v)
      this.isFilled = true
    },
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('checkout-before-edit', 'shipping')
      }
    },
    hasShippingDetails () {
      if (this.currentUser) {
         return this.setMyAddressDetails();
      }
      return false
    },
    setMyAddressDetails () {
      if (!this.currentUser) {
        return false
      }

      if (!this.addresses.length) {
        const defaultLocation = this.$store.getters['locations/getLocations'].find(location => location.code === this.currentUser.default_location_code);
        this.myAddressDetails.customer_id = this.currentUser.id
        this.myAddressDetails.firstname = this.currentUser.firstname
        this.myAddressDetails.lastname = this.currentUser.lastname
        this.myAddressDetails.telephone = this.currentUser.telephone
        this.myAddressDetails.location_code = this.currentUser.default_location_code
        this.myAddressDetails.country = 'UA'
        this.myAddressDetails.city = defaultLocation ? defaultLocation.name : ''
        this.updateShippingDetailsState({
          shipToMyAddress: false,
          showNewAddressForm: true
        })

        return true
      }

      if (this.defaultAddress) {
        this.myAddressDetails = JSON.parse(JSON.stringify(this.defaultAddress))
        return true
      }

      // load manual shipping address from locale storage
      if (this.shippingDetailsState.shipToMyAddress) {
        this.myAddressDetails = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/shipping-details'));
        return true
      }

      // has addresses but none of them are marked as default
      this.myAddressDetails = this.addresses[0]
      this.updateShippingDetailsState({
        shipToMyAddress: true,
        showNewAddressForm: false
      })
      this.useMyAddress()

      return true
    },
    useMyAddress () {
      if (this.shippingDetailsState.shipToMyAddress) {
        this.saveFirstUserShippingDetails(this.shipping);
        this.saveShippingDetails(updateObject(this.shipping, {
          firstName: this.myAddressDetails.firstname,
          lastName: this.myAddressDetails.lastname,
          country: this.myAddressDetails.country,
          state: this.myAddressDetails.state,
          city: this.myAddressDetails.city,
          longitude: this.myAddressDetails.longitude,
          latitude: this.myAddressDetails.latitude,
          api_details: this.myAddressDetails.api_details,
          street: this.myAddressDetails.street,
          house: this.myAddressDetails.house,
          apartment: this.myAddressDetails.apartment,
          postcode: (this.myAddressDetails.postcode && this.myAddressDetails.postcode  === '') ? '' : this.myAddressDetails.postcode,
          phoneNumber: this.myAddressDetails.telephone,
          comment: (this.myAddressDetails.comment && this.myAddressDetails.comment  === '') ? '' : this.myAddressDetails.comment,
          shippingMethod: this.checkoutShippingDetails.shippingMethod,
          shippingCarrier: this.checkoutShippingDetails.shippingCarrier
        }));
      } else {
        this.saveShippingDetails(updateObject(checkoutInitialState.shippingDetails, {
          firstName: this.myAddressDetails.firstname,
          lastName: this.myAddressDetails.lastname,
          phoneNumber: this.myAddressDetails.telephone,
          shippingMethod: this.checkoutShippingDetails.shippingMethod,
          shippingCarrier: this.checkoutShippingDetails.shippingCarrier
        }));
      }
      this.changeCountry()
    },
    getCountryName () {
      return this.getAllowedCountries.find(c => c.code === this.shipping.country) || ''
    },
    changeCountry () {
      this.$bus.$emit('checkout-before-shippingMethods', this.shipping.country)
    },
    getCurrentShippingMethod () {
      let shippingCode = this.shipping.shippingMethod
      return this.shippingMethods ? this.shippingMethods.find(item => item.method_code === shippingCode) : {}
    },
    changeShippingMethod () {
      let currentShippingMethod = this.getCurrentShippingMethod()
      if (currentShippingMethod) {
        this.saveShippingDetails(updateObject(this.shipping, {
          shippingCarrier: currentShippingMethod.carrier_code
        }))
        this.$bus.$emit('checkout-after-shippingMethodChanged', {
          country: this.shipping.country,
          method_code: currentShippingMethod.method_code,
          carrier_code: currentShippingMethod.carrier_code,
          payment_method: this.paymentMethod[0].code
        })
      }
    },
    getActiveShippingAddressId (state = false) {
      if (this.shippingDetailsState.shipToMyAddress || state) {
        const activeShippingAddressId = this.searchActiveShippingAddressId();
        if (activeShippingAddressId) {
          this.changeActiveShippingAddress(activeShippingAddressId)
        }
      } else {
        Logger.warn('The use of the address list was turned off')();
      }
    },
    searchActiveShippingAddressId () {
      if (!this.currentUser) {
          return false
      }
      if (this.addresses.length) {
        return this.defaultAddress ? this.defaultAddress.id : this.addresses[0].id
      }

      return false
    },
    changeActiveShippingAddress (id) {
      this.saveToMyAddress = false
      this.setAddNewAddress(this.saveToMyAddress)
      let defaultAddress = this.addresses.find(address => address.id === id)
      if (!defaultAddress) {
        defaultAddress = this.defaultAddress;
      }
      if (defaultAddress) {
        this.saveShippingDetails(updateObject(this.shipping, {
          ...defaultAddress
        }))
        this.myAddressDetails = defaultAddress
        if (this.$route.name === 'checkout') {
          this.makeDefault({ address_id: id })
            .then((res) => {
              this.$bus.$emit('checkout-after-shippingDetails', res);
              this.updateShippingDetailsState({
                shipToMyAddress: true,
                showNewAddressForm: false
              })
            })
            .catch(() => {
              this.$store.dispatch('notification/spawnNotification', {
                type: 'error',
                message: i18n.t('Error is happened during making address default!'),
                action1: { label: i18n.t('OK') }
              })
            })
        }
        this.useMyAddress()
      }
    },
    notInMethods (method) {
      return !this.shippingMethods.find(item => item.method_code === method)
    },
    loadDataFromStorage (objFirst, objSecond) {
      if (!objFirst || !objSecond) {
        console.error('Cannot load data from storage')
        return
      }
      Object.keys(objFirst).map(key => {
        objFirst[key] = objSecond[key] ? objSecond[key] : objFirst[key]
      })
    },
    setGuestAddressAsShippingAddress (address) {
      this.saveShippingDetails(updateObject(this.shipping, {
        firstName: address.firstname,
        lastName: address.lastname,
        country: address.country,
        state: address.state,
        city: address.city,
        longitude: address.longitude,
        latitude: address.latitude,
        api_details: address.api_details,
        street: address.street,
        house: address.house,
        apartment: address.apartment,
        postcode: (address.postcode && address.postcode === '') ? '' : address.postcode,
        comment: (address.comment && address.comment === '') ? '' : address.comment,
        shippingMethod: this.checkoutShippingDetails.shippingMethod,
        shippingCarrier: this.checkoutShippingDetails.shippingCarrier
      }));
    },
    ...mapActions({
      saveFirstUserShippingDetails: 'checkout/saveFirstUserShippingDetails',
      setAddNewAddress: 'checkout/setAddNewAddress',
      updateShippingDetailsState: 'shipping/updateShippingDetailsState',
      loadAddressList: 'address/loadList',
      makeDefault: 'address/makeDefault',
      saveShippingDetails: 'checkout/saveShippingDetails',
      getGuestShippingDetails: 'checkout/getGuestShippingDetails',
    })
  }
}
